import { render, staticRenderFns } from "./GlobalSalesTable.vue?vue&type=template&id=7379eb2f&"
import script from "./GlobalSalesTable.vue?vue&type=script&lang=js&"
export * from "./GlobalSalesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7379eb2f')) {
      api.createRecord('7379eb2f', component.options)
    } else {
      api.reload('7379eb2f', component.options)
    }
    module.hot.accept("./GlobalSalesTable.vue?vue&type=template&id=7379eb2f&", function () {
      api.rerender('7379eb2f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Tables/GlobalSalesTable.vue"
export default component.exports